import * as tslib_1 from "tslib";
import { BaseModel } from "../_base/model.class";
var Property = /** @class */ (function (_super) {
    tslib_1.__extends(Property, _super);
    function Property(_id, admin, code, owner, type, structure, documentArchive, name, masterCode, taxCode, address, notifyMail1, notifyMail2, expirationNotifyMail1, expirationNotifyMail2, iban, dossier, dossierEmail, administrationStartDate, administrationEndDate, buildingYear, buildingPermitYear, docsStoredAtArchedi, subscription, sharedUser, totalDocsInserted, totalDocsProgressive, phonebook, active, nfcDetails, totalDocsWithExpiration, totalDocsMissingMandatory, newDocumentTree, createdBy, createdAt, updatedBy, updatedAt) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.admin = admin;
        _this.code = code;
        _this.owner = owner;
        _this.type = type;
        _this.structure = structure;
        _this.documentArchive = documentArchive;
        _this.name = name;
        _this.masterCode = masterCode;
        _this.taxCode = taxCode;
        _this.address = address;
        _this.notifyMail1 = notifyMail1;
        _this.notifyMail2 = notifyMail2;
        _this.expirationNotifyMail1 = expirationNotifyMail1;
        _this.expirationNotifyMail2 = expirationNotifyMail2;
        _this.iban = iban;
        _this.dossier = dossier;
        _this.dossierEmail = dossierEmail;
        _this.administrationStartDate = administrationStartDate;
        _this.administrationEndDate = administrationEndDate;
        _this.buildingYear = buildingYear;
        _this.buildingPermitYear = buildingPermitYear;
        _this.docsStoredAtArchedi = docsStoredAtArchedi;
        _this.subscription = subscription;
        _this.sharedUser = sharedUser;
        _this.totalDocsInserted = totalDocsInserted;
        _this.totalDocsProgressive = totalDocsProgressive;
        _this.phonebook = phonebook;
        _this.active = active;
        _this.nfcDetails = nfcDetails;
        _this.totalDocsWithExpiration = totalDocsWithExpiration;
        _this.totalDocsMissingMandatory = totalDocsMissingMandatory;
        _this.newDocumentTree = newDocumentTree;
        _this.createdBy = createdBy;
        _this.createdAt = createdAt;
        _this.updatedBy = updatedBy;
        _this.updatedAt = updatedAt;
        _this.setRequiredFields([
            "_id",
            "admin",
            "owner",
            "type",
            "name",
            "address",
            "notifyMail1",
            "docsStoredAtArchedi",
            "active",
            "nfcDetails",
            "createdBy",
            "createdAt"
        ]);
        return _this;
    }
    return Property;
}(BaseModel));
export { Property };
